import {
  CreateCustomerAccountContact,
  CustomerAccountContact,
} from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const addCustomerAccountContact = (axios: IAxiosInstance) => {
  return async (params: {
    companyID: string;
    customerAccountID: string;
    contact: CreateCustomerAccountContact;
  }) => {
    const response = await axios.noRetry.post<
      IApiResponse<CustomerAccountContact>
    >(`/customer-accounts/${params.customerAccountID}/contacts`, {
      companyID: params.companyID,
      contact: params.contact,
    });

    return response.data;
  };
};
